import colors from "../../../../appConfig/colors";
import { makeStyles } from "@material-ui/core/styles";

const AssessmentFormStyle = makeStyles((theme) => ({
	questionBlock: {
		marginBottom: theme.spacing(3),
	},
	card: {
		marginBottom: theme.spacing(2),
		borderRadius: 12,
		boxShadow: `0 2px 8px ${colors.subtleShadow}`,
		background: colors.white,
		transition: "box-shadow 0.3s cubic-bezier(.25,.8,.25,1), transform 0.3s cubic-bezier(.25,.8,.25,1)",
		border: `1px solid ${colors.dustyGray}`,
		"&:hover": {
			boxShadow: `0 6px 24px ${colors.softBlackOverlay}`,
			transform: "translateY(-2px) scale(1.01)",
		},
	},
	cardHeader: {
		background: colors.whiteSmoke,
		borderBottom: `1px solid ${colors.lightGray}`,
		padding: theme.spacing(2),
	},
	cardContent: {
		padding: theme.spacing(2),
	},
	optionGroup: {
		marginTop: theme.spacing(1),
	},
	paper: {
		marginTop: theme.spacing(3),
		marginBottom: theme.spacing(3),
		padding: theme.spacing(2),
		boxShadow: `5px 5px 10px ${colors.neutralGray}`,
		backgroundColor: colors.primary,
		color: colors.white,
		[theme.breakpoints.up("md")]: {
			marginTop: theme.spacing(4),
			marginBottom: theme.spacing(6),
			direction: "ltr",
		},
		transition: "box-shadow 0.3s",
	},
	headerContainer: {
		width: "100%",
		padding: "20px 10px",
		marginTop: "20px",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		backgroundColor: colors.white,
		gap: theme.spacing(1),
		[theme.breakpoints.down("sm")]: {
			flexDirection: "column",
			padding: "12px",
			marginTop: theme.spacing(2),
			fontSize: "10px",
			width: "80%",
			marginLeft: "auto",
			marginRight: "auto",
		},
	},
	headerSide: {
		flex: 1,
		textAlign: "center",
		padding: "20px",
		color: colors.black,
		"&&": {
			fontWeight: 700,
		},
		[theme.breakpoints.down("sm")]: {
			padding: "12px 6px",
			borderBottom: "0",
			borderTop: "0",
		},
	},
	headerLeft: {
		borderBottom: "2px dashed black",
		borderTop: `4px solid ${colors.charcoalGray}`,
	},
	headerRight: {
		borderTop: "2px dashed black",
		borderBottom: `4px solid ${colors.charcoalGray}`,
	},
	headerImageWrap: {
		padding: "0 10px",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	headerImage: {
		width: 200,
		maxWidth: "40vw",
		height: "auto",
		[theme.breakpoints.down("sm")]: {
			width: 140,
			maxWidth: "60vw",
		},
	},
	customProgress: {
		height: 10,
		borderRadius: 5,
		backgroundColor: colors.silverGray,
		"& .MuiLinearProgress-colorPrimary": {
			backgroundColor: colors.silverGray,
		},
		"& .MuiLinearProgress-barColorPrimary": {
			backgroundColor: colors.mediumDarkGray,
		},
	},
	progressParCaption: {
		marginBottom: 4,
		textAlign: "right",
		color: colors.white,
	},
	submitButton: {
		color: colors.white,
		fontWeight: 600,
		boxShadow: `0 2px 8px ${colors.charcoalGray}`,
		transition: "background 0.2s, box-shadow 0.2s",
		borderRadius: 8,
		textTransform: "none",
		width: "120px",
		"&:hover": {
			backgroundColor: `${colors.darkWarmGray} !important`,
			transition: "background 0.2s, box-shadow 0.2s",
			boxShadow: `0 2px 8px ${colors.charcoalGray}`,
		},
	},
	actionButtonContainer: {
		marginLeft: 15,
		marginRight: 15,
		marginBottom: 8,
	},
	cancelButton: {
		color: colors.charcoalGray,
		textTransform: "none",
		minWidth: "100px",
		backgroundColor: `${colors.nearWhite} !important`,
		"&:hover": {
			backgroundColor: `${colors.warmOffWhite} !important`,
		},
	},
	confirmButton: {
		color: colors.white,
		background: `${colors.primary} !important`,
		textTransform: "none",
		minWidth: "100px",
		"&:hover": {
			backgroundColor: `${colors.darkCrimsonRed} !important`,
		},
	},
	footer: {
		width: "100%",
		height: "60px",
		backgroundColor: "transparent",
		marginTop: "40px",
	},
	statusIcon: {
		color: colors.primary,
		marginLeft: 8,
		verticalAlign: "middle",
	},
	headerText: {
		fontWeight: 700,
	},
	loaderContainer: {
		color: colors.primary,
		marginTop: "30px",
		marginLeft: "5px",
		justifyContent: "center",
		display: "flex",
		width: "100%",
	},
	assessmentHeaderText_1: {
		fontWeight: "bold",
		fontSize: "0.95rem",
		marginBottom: 20,
	},
	assessmentHeaderText_2: {
		fontStyle: "italic",
		fontWeight: "bold",
		fontSize: "0.95rem",
	},
	assessmentHeaderText_3: {
		textDecoration: "underline",
		display: "inline",
	},
	progressParContainer: {
		width: "100%",
		margin: "10px 0 10px 0",
	},
	questionAccordion: {
		border: `1px solid ${colors.dustyGray}`,
		marginBottom: "10px",
		background: colors.veryLightGray,
	},
	questionCard: {
		width: "100%",
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		flexWrap: "nowrap",
	},
	questionContainer: {
		display: "flex",
		alignItems: "center",
		flexShrink: 1,
		gap: "1rem",
	},
	questionNumberLabel: {
		fontWeight: 600,
		fontSize: "2rem",
		minWidth: "2rem",
		textAlign: "center",
		color: colors.primary,
	},
	questionIconBox: {
		width: 60,
	},
	questionCategoryContainer: {
		display: "flex",
		flexDirection: "column",
		minWidth: 0,
	},
	questionCategoryText: {
		margin: 0,
		lineHeight: 1.2,
		wordBreak: "break-word",
		marginBottom: "8px",
		fontSize: "1.1em",
	},
	questionCategoryDescription: {
		color: colors.warmCharcoal,
		margin: 0,
		fontSize: "0.9rem",
		lineHeight: 1.2,
	},
	categoryContainerStatus: {
		display: "flex",
		alignItems: "center",
		flexShrink: 0,
		whiteSpace: "nowrap",
		fontSize: "0.9rem",
		color: colors.neutralDarkGray,
		marginLeft: "1rem",
	},
	accordionDetails: {
		display: "block",
	},
	accordion: {
		border: `1px solid ${colors.dustyGray}`,
		marginBottom: "10px",
	},
	questionTitleContainer: {
		flex: 1,
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
	},
	questionContainerStatus: {
		display: "flex",
		alignItems: "center",
		fontSize: "0.85rem",
		color: colors.neutralDarkGray,
	},
	questionOptionContainer: {
		marginRight: "50px",
	},
	questionsDivider: {
		backgroundColor: colors.charcoalGray,
		margin: "16px 0",
	},
	submitButtonContainer: {
		paddingTop: "20px",
	},
	submitLoader: {
		color: colors.white,
	},
	submitConfirmationDialogHeader: {
		backgroundColor: colors.primary,
		color: colors.white,
	},
	submitConfirmationDialogBody: {
		color: colors.crimsonRed,
		marginBottom: "10px",
	},
	tooltipContent: {
		backgroundColor: colors.white,
		width: "100%",
		color: colors.black,
		padding: "10px 14px",
		fontSize: "14px",
		margin: 0,
		lineHeight: "1.6",
		letterSpacing: "0.3px",
		fontWeight: 400,
		whiteSpace: "pre-line",
	},
}));

export default AssessmentFormStyle;
